module.exports = __webpack_public_path__ + "img/sbb_tip.f07af936.png";